var _propsToAccessibilityComponent=require('./propsToAccessibilityComponent');var _propsToAccessibilityComponent2=_interopRequireDefault(_propsToAccessibilityComponent);
var _propsToAriaRole=require('./propsToAriaRole');var _propsToAriaRole2=_interopRequireDefault(_propsToAriaRole);
var _propsToTabIndex=require('./propsToTabIndex');var _propsToTabIndex2=_interopRequireDefault(_propsToTabIndex);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

module.exports={
propsToAccessibilityComponent:_propsToAccessibilityComponent2.default,
propsToAriaRole:_propsToAriaRole2.default,
propsToTabIndex:_propsToTabIndex2.default};


// WEBPACK FOOTER //
// ./~/react-native-web/dist/modules/AccessibilityUtil/index.js